<template>
  <div class="gd624-chart common-border">
    <div class="common-border2">
      <el-row class="header">
        <el-col :span="24">
          <span class="sensor-name">{{ config.name }}:</span>
          <span class="value">{{ config.value }}</span>
          <span class="unit-name">{{ config.unitName }}</span>
        </el-col>
      </el-row>

      <div class="chart-box">
        <v-chart :options="opt" :autoresize="true"></v-chart>
      </div>
    </div>
  </div>
</template>

<script>
import { lineAreaStyle } from '@/echartOption/lineAreaStyle';
import { graColor } from '@/views/realdata/FCBR-100/options';

export default {
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      opt: lineAreaStyle({
        color: '#009fe9',
        // dataZoom: {
        //   start: 0,
        //   type: 'inside'
        // },
        series: [
          {
            symbol: 'emptyCircle',
            areaStyle: { color: graColor('rgb(3, 153, 224)', 'rgba(3, 153, 224, 0.1)') }
          }
        ],
        xAxis: {
          axisLine: {
            lineStyle: {
              color: '#009fe9'
            }
          }
        },
        grid: {
          top: 28,
          left: 30,
          right: 30,
          bottom: 20
        }
      })
    };
  },
  methods: {
    setData(data) {
      this.opt.series[0].data = data;
    }
  },
  watch: {
    'config.data': {
      handler: 'setData',
      deep: true,
      immediate: true
    }
  }
};
</script>

<style lang="scss">
.gd624-chart {
  --h: calc(100% / var(--row-num) - var(--gap) * (var(--row-num) - 1) / var(--row-num));
  --max-h: calc(50% - var(--gap) * (var(--row-num) - 1) / var(--row-num));

  box-sizing: border-box;
  width: calc(100% / var(--col-num) - var(--gap) * (var(--col-num) - 1) / var(--col-num));
  height: max(var(--max-h), var(--h));
  padding: 4px;

  .header {
    font-size: 18px;
    background: #013c5d;
    padding: 12px 10px;
    border-radius: 4px;
    font-weight: bold;

    .sensor-name,
    .value,
    .unit-name {
      margin-right: 5px;
    }

    .unit-name {
      font-size: 12px;
    }
  }

  .common-border2 {
    border: 1px solid #3c4c73;
    height: 100%;
  }

  .center {
    padding: 5px;
    font-size: 16px;
    .el-col {
      text-align: center;
    }
  }

  .chart-box {
    height: calc(100% - 48px);
  }
}
</style>
